export default __webpack_public_path__ + "static/star-b8613b38cfd991bce21b61d9f6bc2bb0.png";